import { createContext, useContext, type ReactNode, createElement } from 'react';
import en from './en-US.js';
import de from './de-DE.js';

export type Locale = 'en-US' | 'de-DE';

const dictionaries: Record<Locale, Record<string, string>> = {
  'en-US': en,
  'de-DE': de,
};

function translate(locale: Locale, key: string, vars?: Record<string, string>): string {
  const dict = dictionaries[locale] ?? dictionaries['en-US'];
  const fallback = dictionaries['en-US'][key];
  let str = dict[key] ?? fallback ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replace(`{${k}}`, v);
    }
  }
  return str;
}

const I18nContext = createContext<Locale>('en-US');

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return createElement(I18nContext.Provider, { value: locale }, children);
}

export function useLocale(): Locale {
  return useContext(I18nContext);
}

export function useT(): (key: string, vars?: Record<string, string>) => string {
  const locale = useLocale();
  return (key, vars) => translate(locale, key, vars);
}
